import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Avatar } from '@/components/ui/avatar';
import { MapPin, Mail, Phone, Star } from 'lucide-react';
import { UserProfile } from '@/types/user';

interface ProfileCardProps {
  profile: UserProfile;
  rating: number;
}

export function ProfileCard({ profile, rating }: ProfileCardProps) {
  const navigate = useNavigate();

  return (
    <Card className="p-6">
      <div className="flex flex-col items-center">
        <Avatar className="h-24 w-24">
          <div className="bg-blue-600 w-full h-full flex items-center justify-center text-white text-2xl">
            {profile?.name?.charAt(0).toUpperCase()}
          </div>
        </Avatar>
        <h2 className="mt-4 text-xl font-semibold">{profile?.name}</h2>
        <p className="text-gray-600 text-sm mt-1">{profile?.city}</p>
      </div>

      <div className="mt-6 space-y-4">
        <div className="flex items-center gap-3">
          <MapPin className="h-5 w-5 text-gray-500 flex-shrink-0" />
          <div className="flex flex-col">
            <span className="text-sm">{profile?.city}</span>
            <Button
              variant="link"
              className="h-auto p-0 text-blue-600 hover:text-blue-700 text-sm"
              onClick={() => navigate(`/prefeitura/${profile?.city.toLowerCase().replace(/ /g, '-')}`)}
            >
              Acessar Prefeitura
            </Button>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <MapPin className="h-5 w-5 text-gray-500" />
          <span className="text-sm">{profile?.address}</span>
        </div>
        <div className="flex items-center gap-3">
          <Mail className="h-5 w-5 text-gray-500 flex-shrink-0" />
          <span className="text-sm break-all">{profile?.email}</span>
        </div>
        <div className="flex items-center gap-3">
          <Phone className="h-5 w-5 text-gray-500 flex-shrink-0" />
          <span className="text-sm">{profile?.phone}</span>
        </div>
      </div>

      <div className="mt-6">
        <h3 className="font-semibold mb-2">Serviços Oferecidos</h3>
        <p className="text-sm text-gray-600">{profile?.services}</p>
      </div>

      <div className="mt-6">
        <h3 className="font-semibold mb-2">Sobre</h3>
        <p className="text-sm text-gray-600">{profile?.description}</p>
      </div>
    </Card>
  );
}